var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2367 20.5908L52.5 34.4233V23.7545C52.5 20.7989 49.2295 19.0047 46.7367 20.5908L25 34.4233V3.75C25 1.67891 23.3211 0 21.25 0H3.75C1.67891 0 0 1.67891 0 3.75V66.25C0 68.3211 1.67891 70 3.75 70H76.25C78.3211 70 80 68.3211 80 66.25V23.7545C80 20.7988 76.7295 19.0047 74.2367 20.5908Z",
    fill: "#F26739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.1f13b27410aace58fbe8b1667787e452.svg";
export { ForwardRef as ReactComponent };